import { ContentCardForErrors } from 'src/components/common/ContentCard';
import { GridType } from 'src/enums/GridType';
import { useTranslation } from 'react-i18next';
import { Button, Link, Typography, useMediaQuery } from '@mui/material';
import { FacebookAdsPage } from 'src/components/facebook/page/Page';
import { FacebookSignIn } from 'src/components/facebook/FacebookSignIn';
import { ErrorEvent, useErrorContent } from 'src/hooks/common/useErrorContent';
import { GradeMyAccountBtn } from 'src/components/common/GradeMyAccountBtn';
import { ServiceType } from 'src/enums/ServiceType';
import { OrionTheme } from 'src/components/theme/orion/Theme';
import ErrorFooter from 'src/components/facebook/errors/ErrorFooter';

export const FacebookAdsError = (): JSX.Element => {
  const { t } = useTranslation([ServiceType.FACEBOOK]);
  const { event, errorTitle, errorBody, email } = useErrorContent();
  const isMobile = useMediaQuery(OrionTheme.breakpoints.down('sm'));

  return (
    <FacebookAdsPage gridType={GridType.FORM} additionalFooter={<ErrorFooter />}>
      <ContentCardForErrors title={errorTitle} body={errorBody}>
        {event === ErrorEvent.TIMED_OUT ? (
          // we are just showing content error body in this case
          <></>
        ) : event === ErrorEvent.PROCESS ? (
          <>
            <Button
              variant="contained"
              color="secondary"
              size="medium"
              LinkComponent={Link}
              href="https://www.wordstream.com/learn"
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              {t('error.button_nospend')}
            </Button>
          </>
        ) : email ? (
          <>
            <Typography variant="caption" sx={{ pb: isMobile ? 2 : 3 }}>
              {t('error.caption')}
            </Typography>
            <FacebookSignIn />
          </>
        ) : (
          <>
            <Typography variant="caption" sx={{ pb: isMobile ? 2 : 3 }}>
              {t('error.caption')}
            </Typography>
            <GradeMyAccountBtn />
          </>
        )}
      </ContentCardForErrors>
    </FacebookAdsPage>
  );
};
